export const SendIcon = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <g clip-path="url(#clip0_4_1654)">
            <path d="M18.3334 1.66669L9.16675 10.8334M18.3334 1.66669L12.5001 18.3334L9.16675 10.8334M18.3334 1.66669L1.66675 7.50002L9.16675 10.8334" stroke="white" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_4_1654">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
}